const appendScript = (src: string, async = false, defer = false, customAttributes: Record<string, string> = {}) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  script.async = async;
  script.defer = defer;

  Object.entries(customAttributes).forEach(([name, value]) => {
    script.setAttribute(name, value);
  });

  document.head.appendChild(script);
};

export default appendScript;
